( function( document ) {
	'use strict';

/* -- Variables -- */

	// the interactive
	let interactive;

/* -- Function -- */

	function openClose( profile ) {
		if ( profile.classList.contains( 'profiles--active' ) ){
			profile.classList.remove( 'profiles--active' );
		} else {
			profile.classList.add( 'profiles--active' );
			dataLayer.push({
				'event': 'Interactive',
				'category': 'Interactive',
				'action': 'Accordion opened',
				'label': profile.id
			});
		}
	}

/* -- Application -- */

	function app() {
		interactive = document.getElementById( 'china-party-congress' );

		const profiles = [].slice.call( interactive.querySelectorAll( '.profiles__person' ) );
		profiles.map( function ( profile ) {
			const elements = [].slice.call( profile.querySelectorAll( '.profiles__action, .person__photo, h3' ) );
			elements.map( element => element.addEventListener( 'click', () =>	openClose( profile ) ) );
		});
	}

	// Start the whole thing when the DOM is complete
	document.addEventListener( 'readystatechange', function() {
		document.readyState === 'interactive' && app();
	}, false );

})( document );
